module.exports = "<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-xs-12 col-sm-12 col-md-12\">\n      <spinner>\n        <h4>{{ 'COMUN.LABEL_CARGANDO' | translate }}</h4>\n      </spinner>\n\n      <router-outlet></router-outlet>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main